<template>
  <component :is="socialIcon" :color="socialIconColor" />
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  icon: {
    type: String,
    required: true,
  },
  hovered: {
    type: Boolean,
    required: true,
  },
  hoverColor: {
    type: String,
    default: "#98A2B3",
  },
  color: {
    type: String,
    default: "#98A2B3"
  }
});

const socialIconColor = computed(() =>
  props.hovered ? props.hoverColor : props.color,
);

const modules = import.meta.glob("./icons/*.vue", { eager: true });

const styleIconPath = computed(() => `./icons/${props.icon}-icon.vue`);

const socialIcon = computed(() => modules[styleIconPath.value]?.default);
</script>

<style scoped></style>
